export const StoryTellerLocked = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="52"
    height="52"
    viewBox="0 0 52 52"
  >
    <g
      id="Storyteller_Badge_-_Locked"
      data-name="Storyteller Badge - Locked"
      transform="translate(1 1)"
    >
      <circle
        id="Ellipse_36"
        data-name="Ellipse 36"
        cx="25"
        cy="25"
        r="25"
        fill="#e6e6e6"
        stroke="#666"
        strokeLinecap="round"
        strokeWidth="2"
      />
      <circle
        id="Ellipse_35"
        data-name="Ellipse 35"
        cx="2.718"
        cy="2.718"
        r="2.718"
        transform="translate(16.733 16.627)"
        fill="none"
      />
      <path
        id="Path_2025"
        data-name="Path 2025"
        d="M50.606,28.483H23.054a1.9,1.9,0,0,0-1.9,1.9V49.969a1.9,1.9,0,0,0,1.9,1.9H50.606a1.9,1.9,0,0,0,1.9-1.9V30.385A1.9,1.9,0,0,0,50.606,28.483Zm-19.6,1.691a4.349,4.349,0,1,1-4.348,4.349A4.353,4.353,0,0,1,31.01,30.174Zm7.223,19.835a.843.843,0,0,1-.11.008.815.815,0,0,1-.807-.706c-.016-.115-.032-.248-.049-.4-.739-6.213-3.656-7.01-6.114-7.01-4.586,0-5.811,3.35-6.276,6.474l6.153-.057h.008a.815.815,0,0,1,.007,1.63l-7.094.065a.848.848,0,0,1-.622-.279.816.816,0,0,1-.192-.654c.015-.1.031-.23.049-.374.261-2.086,1.058-8.435,7.967-8.435,6.729,0,7.485,6.359,7.733,8.448.016.139.032.264.046.371A.815.815,0,0,1,38.233,50.009ZM49.3,44.621H41.879a.815.815,0,0,1,0-1.63H49.3a.815.815,0,0,1,0,1.63Zm0-3.533h-9.27a.815.815,0,1,1,0-1.63H49.3a.815.815,0,1,1,0,1.63Zm0-3.533H39.129a.815.815,0,1,1,0-1.63H49.3a.815.815,0,1,1,0,1.63Z"
        transform="translate(-11.558 -15.177)"
        fill="none"
      />
      <g
        id="Group_2667"
        data-name="Group 2667"
        transform="translate(7.963 11.675)"
      >
        <path
          id="Path_2026"
          data-name="Path 2026"
          d="M49.237,25.483H21.685a3.537,3.537,0,0,0-3.533,3.533V48.6a3.537,3.537,0,0,0,3.533,3.533H49.237A3.537,3.537,0,0,0,52.769,48.6V29.016A3.537,3.537,0,0,0,49.237,25.483Zm1.9,23.116a1.9,1.9,0,0,1-1.9,1.9H21.685a1.9,1.9,0,0,1-1.9-1.9V29.016a1.9,1.9,0,0,1,1.9-1.9H49.237a1.9,1.9,0,0,1,1.9,1.9Z"
          transform="translate(-18.152 -25.483)"
          fill="#666"
        />
        <path
          id="Path_2027"
          data-name="Path 2027"
          d="M35.637,40.293a4.349,4.349,0,1,0-4.348-4.349A4.354,4.354,0,0,0,35.637,40.293Zm0-7.067a2.718,2.718,0,1,1-2.718,2.718A2.718,2.718,0,0,1,35.637,33.225Z"
          transform="translate(-24.149 -28.273)"
          fill="#666"
        />
        <path
          id="Path_2028"
          data-name="Path 2028"
          d="M40.545,58.625c-.248-2.089-1-8.448-7.733-8.448-6.909,0-7.705,6.349-7.967,8.435-.018.144-.034.27-.049.374a.816.816,0,0,0,.192.654.848.848,0,0,0,.622.279l7.094-.065a.815.815,0,0,0-.007-1.63h-.008l-6.153.057c.465-3.124,1.69-6.474,6.276-6.474,2.458,0,5.375.8,6.114,7.01.018.149.034.283.049.4a.815.815,0,0,0,.807.706.843.843,0,0,0,.11-.008.815.815,0,0,0,.7-.917C40.577,58.889,40.561,58.764,40.545,58.625Z"
          transform="translate(-21.181 -36.756)"
          fill="#666"
        />
        <path
          id="Path_2029"
          data-name="Path 2029"
          d="M63.711,42.177H53.544a.815.815,0,1,0,0,1.63H63.711a.815.815,0,0,0,0-1.63Z"
          transform="translate(-33.937 -33.104)"
          fill="#666"
        />
        <path
          id="Path_2030"
          data-name="Path 2030"
          d="M64.464,48.677h-9.27a.815.815,0,0,0,0,1.63h9.27a.815.815,0,0,0,0-1.63Z"
          transform="translate(-34.69 -36.072)"
          fill="#666"
        />
        <path
          id="Path_2031"
          data-name="Path 2031"
          d="M66.021,55.177H58.6a.815.815,0,0,0,0,1.63h7.417a.815.815,0,0,0,0-1.63Z"
          transform="translate(-36.247 -39.039)"
          fill="#666"
        />
      </g>
    </g>
  </svg>
);

export const StoryTellerUnLocked = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="52"
    height="56"
    viewBox="0 0 52 56"
  >
    <defs>
      <linearGradient
        id="linear-gradient"
        x1="0.5"
        x2="0.5"
        y2="1"
        gradientUnits="objectBoundingBox"
      >
        <stop offset="0" stopColor="#d11947" />
        <stop offset="1" stopColor="#8d0034" />
      </linearGradient>
    </defs>
    <g
      id="Storyteller_Badge_-_Unlocked"
      data-name="Storyteller Badge - Unlocked"
      transform="translate(1 5)"
    >
      <circle
        id="Ellipse_36"
        data-name="Ellipse 36"
        cx="25"
        cy="25"
        r="25"
        stroke="#8d0034"
        strokeLinecap="round"
        strokeWidth="2"
        fill="url(#linear-gradient)"
      />
      <circle
        id="Ellipse_35"
        data-name="Ellipse 35"
        cx="2.718"
        cy="2.718"
        r="2.718"
        transform="translate(16.733 16.627)"
        fill="none"
      />
      <path
        id="Path_2025"
        data-name="Path 2025"
        d="M50.606,28.483H23.054a1.9,1.9,0,0,0-1.9,1.9V49.969a1.9,1.9,0,0,0,1.9,1.9H50.606a1.9,1.9,0,0,0,1.9-1.9V30.385A1.9,1.9,0,0,0,50.606,28.483Zm-19.6,1.691a4.349,4.349,0,1,1-4.348,4.349A4.353,4.353,0,0,1,31.01,30.174Zm7.223,19.835a.843.843,0,0,1-.11.008.815.815,0,0,1-.807-.706c-.016-.115-.032-.248-.049-.4-.739-6.213-3.656-7.01-6.114-7.01-4.586,0-5.811,3.35-6.276,6.474l6.153-.057h.008a.815.815,0,0,1,.007,1.63l-7.094.065a.848.848,0,0,1-.622-.279.816.816,0,0,1-.192-.654c.015-.1.031-.23.049-.374.261-2.086,1.058-8.435,7.967-8.435,6.729,0,7.485,6.359,7.733,8.448.016.139.032.264.046.371A.815.815,0,0,1,38.233,50.009ZM49.3,44.621H41.879a.815.815,0,0,1,0-1.63H49.3a.815.815,0,0,1,0,1.63Zm0-3.533h-9.27a.815.815,0,1,1,0-1.63H49.3a.815.815,0,1,1,0,1.63Zm0-3.533H39.129a.815.815,0,1,1,0-1.63H49.3a.815.815,0,1,1,0,1.63Z"
        transform="translate(-11.558 -15.177)"
        fill="none"
      />
      <g
        id="Group_2667"
        data-name="Group 2667"
        transform="translate(7.963 11.675)"
      >
        <path
          id="Path_2026"
          data-name="Path 2026"
          d="M49.237,25.483H21.685a3.537,3.537,0,0,0-3.533,3.533V48.6a3.537,3.537,0,0,0,3.533,3.533H49.237A3.537,3.537,0,0,0,52.769,48.6V29.016A3.537,3.537,0,0,0,49.237,25.483Zm1.9,23.116a1.9,1.9,0,0,1-1.9,1.9H21.685a1.9,1.9,0,0,1-1.9-1.9V29.016a1.9,1.9,0,0,1,1.9-1.9H49.237a1.9,1.9,0,0,1,1.9,1.9Z"
          transform="translate(-18.152 -25.483)"
          fill="#fff"
        />
        <path
          id="Path_2027"
          data-name="Path 2027"
          d="M35.637,40.293a4.349,4.349,0,1,0-4.348-4.349A4.354,4.354,0,0,0,35.637,40.293Zm0-7.067a2.718,2.718,0,1,1-2.718,2.718A2.718,2.718,0,0,1,35.637,33.225Z"
          transform="translate(-24.149 -28.273)"
          fill="#fff"
        />
        <path
          id="Path_2028"
          data-name="Path 2028"
          d="M40.545,58.625c-.248-2.089-1-8.448-7.733-8.448-6.909,0-7.705,6.349-7.967,8.435-.018.144-.034.27-.049.374a.816.816,0,0,0,.192.654.848.848,0,0,0,.622.279l7.094-.065a.815.815,0,0,0-.007-1.63h-.008l-6.153.057c.465-3.124,1.69-6.474,6.276-6.474,2.458,0,5.375.8,6.114,7.01.018.149.034.283.049.4a.815.815,0,0,0,.807.706.843.843,0,0,0,.11-.008.815.815,0,0,0,.7-.917C40.577,58.889,40.561,58.764,40.545,58.625Z"
          transform="translate(-21.181 -36.756)"
          fill="#fff"
        />
        <path
          id="Path_2029"
          data-name="Path 2029"
          d="M63.711,42.177H53.544a.815.815,0,1,0,0,1.63H63.711a.815.815,0,0,0,0-1.63Z"
          transform="translate(-33.937 -33.104)"
          fill="#fff"
        />
        <path
          id="Path_2030"
          data-name="Path 2030"
          d="M64.464,48.677h-9.27a.815.815,0,0,0,0,1.63h9.27a.815.815,0,0,0,0-1.63Z"
          transform="translate(-34.69 -36.072)"
          fill="#fff"
        />
        <path
          id="Path_2031"
          data-name="Path 2031"
          d="M66.021,55.177H58.6a.815.815,0,0,0,0,1.63h7.417a.815.815,0,0,0,0-1.63Z"
          transform="translate(-36.247 -39.039)"
          fill="#fff"
        />
      </g>
      <g id="Group_2807" data-name="Group 2807" transform="translate(34 -5)">
        <circle
          id="Ellipse_55"
          data-name="Ellipse 55"
          cx="8.5"
          cy="8.5"
          r="8.5"
          fill="#008a1c"
        />
        <g
          id="Check_Mark_-_S"
          data-name="Check Mark - S"
          transform="translate(4 5.29)"
        >
          <path
            id="Check_Mark_-_S-2"
            data-name="Check Mark - S"
            d="M9.381,2.22a.442.442,0,0,0-.639,0L3.572,7.414,1.262,5.136a.442.442,0,0,0-.631,0,.459.459,0,0,0,0,.639l2.63,2.6a.483.483,0,0,0,.32.131.459.459,0,0,0,.32-.139l5.481-5.53A.451.451,0,0,0,9.381,2.22Z"
            transform="translate(-0.502 -2.083)"
            fill="#fff"
          />
        </g>
      </g>
    </g>
  </svg>
);
